<template>
  <div class="toast-container position-fixed top-0 end-0 p-3">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      :ref="'toast-' + toast.id"
      :class="['toast', toast.type]"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div :class="['toast-header', toast.headerClass]">
        <strong class="me-auto">{{ toast.title }}</strong>
        <button
          type="button"
          class="btn-close"
          @click="removeToast(toast.id)"
          aria-label="Close"
        ></button>
      </div>
      <div class="toast-body">{{ toast.message }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// Toast is available via window.bootstrap from CDN

export default {
  name: "ToastNotification",
  computed: {
    ...mapState(["toasts"]),
  },
  watch: {
    toasts: {
      handler(newToasts) {
        this.$nextTick(() => {
          newToasts.forEach((toast) => {
            const toastElement = this.$refs["toast-" + toast.id];
            if (toastElement && toastElement[0]) {
              const bootstrapToast = new window.bootstrap.Toast(toastElement[0], {
                delay: 7000,
              });
              bootstrapToast.show();
            }
          });
        });
      },
      deep: true,
    },
  },
  methods: {
    removeToast(id) {
      this.$store.commit("removeToast", id);
    },
  },
};
</script>

<style>
.toast-header-success {
  background-color: #d8ffd8;
}
.toast-header-danger {
  background-color: #ffdada;
}
.toast-success {
  background-color: #00a000;
}
.toast-danger {
  background-color: #ff2c2c;
}
.toast-body {
  color: white;
}
</style>
